import { fetchNegotiationMessages } from '@/api/studentRoom'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchNegotiationHistoryAsync = createAsyncThunk(
  'negotiationHistory/fetchMessages',
  async (
    {
      negotiationId,
      page = 1,
      reset = false,
    }: {
      negotiationId: string | number
      page?: number
      reset?: boolean
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchNegotiationMessages(negotiationId, page)
      return {
        messages: data.results,
        negotiationId: Number(negotiationId),
        hasMore: !!data.next,
        page,
        totalCount: data.count,
        reset,
      }
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : 'Failed to fetch negotiation messages'
      )
    }
  }
)
